import SimpleHeader from '../../components/layout/SimpleHeader';
import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SelectCampus from '../../components/SelectCampus';
import Button from '../../components/Button';
import { Checkbox, Select, Table, TableColumnsType } from 'antd';
import Pagination from '../../components/Pagination';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import ErrorResponse from '../../components/ErrorResponse';
import { getCommonCodeLabel } from '../../lib/store';
import {
  useCancelBookLoanMutation,
  useGetClassQuery,
  useGetReturnBooksQuery,
} from '../../api/books/bookManagement.api';
import moment from 'moment/moment';
import { useSnackbar } from 'notistack';
import { infoVariant, successVariant } from '../../lib/barVariant';
import useBarcodeScanner from '../../hooks/useBarcodeScanner';
import useAxios from '../../hooks/useAxios';
import { IGetSemesters, ISemester } from '../../models/semesters.model';
import { getSemesters } from '../../api/semesters.api';

const ReturnBooks = () => {
  const { t, i18n } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { currentCampus: campusCode } = useSelector(
    (state: RootState) => state.auth,
  );
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  const bookStatusList = commonCodes.find(
    (item) => item.commonCode === 'BK0002',
  )?.detailCode;
  // PR0002 = 학기유형
  const PR0002 = commonCodes.find((item) => item.commonCode === 'PR0002')?.detailCode;
  const [page, setPage] = useState(1);
  const keywordRef = useRef<any>();
  const [searchData, setSearchData] = useState<any>({
    campusCode,
    keyword: '',
    pageSize: 10,
    page: 1,
    //
    bookStatus: null,
    classCodeList: null,
    semesterCode: null,
    semesterType: null
    //
  });
  const [selectedBooks, setSelectedBooks] = useState<any>([]);
  const [selectedBooksKeys, setSelectedBooksKeys] = useState<React.Key[]>([]);
  const barcode = useBarcodeScanner();
  const [bookStatus, setBookStatus] = useState(null);
  const [semesterCode, setSemesterCode] = useState('null');
  const [semesterType, setSemesterType] = useState("");
  const [semesterData, setSemesterData] = useState<ISemester[]>([]);

  const {
    data: copyBooksResponse,
    isFetching,
    error,
  } = useGetReturnBooksQuery(searchData);
  // } = useGetReturnBooksQuery(searchData, { skip: !searchData?.campusCode });
  const [
    returnBooksTrigger,
    { isSuccess: isReturnSuccess, isLoading: isReturnLoading },
  ] = useCancelBookLoanMutation();
  const copyBooks = copyBooksResponse?.data;

  const [classCodeList, setClassCodeList] = useState<any>([]);
  const [isChecked, setIsChecked] = useState(false);

  const {
    data: res,
    isLoading,
    error: error2,
    execute,
  } = useAxios<IGetSemesters>();

  useEffect(() => {
    execute(getSemesters());
  }, []);

  const {
    data,
    error: errro2,
    isLoading: isLoading2,
  } = useGetClassQuery(
    {
      campusCode,
      semesterCode: semesterCode === 'null' ? null : semesterCode,
    },
    { skip: !campusCode || !semesterCode },
  );

  useEffect(() => {
    setClassCodeList([]);
  }, [semesterCode]);

  useEffect(() => {
    fnSetSemesterData(semesterType);
  }, [res]);

  useEffect(() => {
    fnSetSemesterData(semesterType);
  }, [semesterType]);

  const fnSetSemesterData = (semesterType : string) => {
    if(res) {
      let data: ISemester[] = _.cloneDeep(res.data);

      if(semesterType) {
        data = data.filter((item: any) => item.semesterType === semesterType);
      }

      if(data.length === 0) {
        setSemesterCode('');
      }

      setSemesterData(data);
    }
  }

  const returnBooksColumns: TableColumnsType<object> = [
    {
      title: t('booksManagement.books.column1'),
      dataIndex: 'no',
      align: 'center',
      width: 50,
    },
    {
      title: t('booksManagement.books.column2'),
      dataIndex: 'bookName',
      align: 'center',
      width: 300,
      ellipsis: true,
      render: (value) => {
        return <div className="text-left ant-table-cell-ellipsis">{value}</div>;
      },
    },
    {
      title: t('booksManagement.books.column4'),
      dataIndex: 'isbn',
      align: 'center',
    },
    {
      title: t('booksManagement.books.column19'),
      dataIndex: 'bookSeq',
      align: 'center',
      width: 80,
      render: (value: number) => (value ? value : '-'),
    },
    {
      title: t('booksManagement.books.column31'),
      dataIndex: 'bookStatus',
      align: 'center',
      render: (value: string) =>
        value ? getCommonCodeLabel('BK0002', value, i18n.language) : '-',
    },
    {
      title: t('class.class.column57'),
      dataIndex: 'className',
      align: 'center',
      render: (value: string, record: any) =>
        value ? `${value}(${record?.semesterName})` : '-',
    },
    {
      title: t('booksManagement.books.column14'),
      dataIndex: 'memberName',
      align: 'center',
      render: (value: string, record: any) =>
        value ? `${value}(${record?.webId})` : '-',
    },
    {
      title: t('booksManagement.books.column20'),
      dataIndex: 'lendingDate',
      align: 'center',
      render: (value) => {
        return value ? moment(value).format('YYYY-MM-DD') : '-';
      },
    },
    {
      title: t('booksManagement.books.column21'),
      dataIndex: 'returnPlanDate',
      align: 'center',
      render: (value, record: any) => {
        return record?.overdueDay ? (
          <>
            {moment(record?.returnPlanDate).format('YYYY-MM-DD')}
            <span style={{ color: 'red' }}>
              ({`+${record?.overdueDay}`}
              {t('booksManagement.books.column22')})
            </span>
          </>
        ) : value ? (
          moment(value).format('YYYY-MM-DD')
        ) : (
          '-'
        );
      },
    },
  ];

  const rowSelection = {
    selectedRowKeys: selectedBooksKeys,
    onChange: (selectedRowKeys: React.Key[], selectedRows: any) => {
      setSelectedBooks(selectedRows);
      setSelectedBooksKeys(selectedRowKeys);
    },
    getCheckboxProps: (record: any) => ({
      disabled: record.bookStatus === 'FU' || !record?.bookStatus,
    }),
  };
  const handleSelectedReset = () => {
    setSelectedBooksKeys([]);
    setSelectedBooks([]);
  };

  useEffect(() => {
    if (!campusCode) return;
    setSearchData({ ...searchData, page: 1, keyword: '', campusCode });
  }, [campusCode]);

  useEffect(() => {
    if (!page) return;

    setSearchData({ ...searchData, page });
  }, [page]);

  useEffect(() => {
    if (!isReturnLoading && isReturnSuccess) {
      enqueueSnackbar(t('booksManagement.books.message19'), successVariant);
    }
  }, [isReturnLoading, isReturnSuccess]);

  useEffect(() => {
    if (barcode != null && keywordRef) {
      setSearchData({ ...searchData, keyword: barcode, page: 1 });
      handleSelectedReset();
      keywordRef.current.value = barcode;
    }
  }, [barcode]);

  // useEffect(() => {
  //   if (!bookStatus) return;
  //   setSearchData({ ...searchData, page: 1, keyword: '', bookStatus });
  // }, [bookStatus]);

  const handleChange = (value: any) => {
    if (value.includes('null')) {
      if (value.length === 1) {
        // "전체"가 선택된 경우 모든 데이터를 선택합니다.
        const allValues = data?.data?.map((item: any) => item.classCode) || [];
        setClassCodeList(allValues);
      } else {
        // "전체"가 해제된 경우 선택을 모두 해제합니다.
        setClassCodeList([]);
      }
    } else {
      setClassCodeList(value);
    }
  };

  const onChange = (e: any) => {
    if (!isChecked) {
      setIsChecked(true);
    } else {
      setIsChecked(false);
    }
  };
  return (
    <>
      <SimpleHeader
        iconFile="icon-event-big.svg"
        parentMenu={t('common.menu.book')}
        currentMenu={t('booksManagement.books.column41')}
        onlyTitle={true}
      />
      <div className="common-search">
        <div className="search-area">
          <ul className="search-bx">
            <li>
              <label>{t('common.menu.campus')}</label>
              <div>
                <SelectCampus />
              </div>
            </li>
            <li>
              <label>{t('booksManagement.books.column31')}</label>
              <div>
                <Select
                  value={bookStatus}
                  onChange={(value) => setBookStatus(value)}
                  options={[
                    { label: '전체', value: null },
                    ...(Array.isArray(bookStatusList)
                      ? bookStatusList
                          ?.filter((items: any) => items.detailCode !== 'NA')
                          ?.map((item: any) => ({
                            label:
                              i18n.language === 'ko'
                                ? item.korName
                                : item.engName,
                            value: item?.detailCode,
                          }))
                      : []),
                  ]}
                ></Select>
              </div>
            </li>
            <li>
              <label>
                {t('program.semester.column11')}
              </label>
              <Select
                className="w-120p"
                value={semesterType}
                onChange={value => setSemesterType(value)}
              >
                <Select.Option key={'all'} value={''}>
                  {t('common.text.all')}
                </Select.Option>
                {
                  PR0002?.map(({korName: label, detailCode: value}) => {
                    return (
                      <Select.Option key={value} value={value}>
                        {label}
                      </Select.Option>
                    )
                  })
                }
              </Select>
            </li>      
            <li>
              <label>{t('common.column.semester')}</label>
              <div>
                <Select
                  // placeholder={t('class.class.placeholder4')}
                  placeholder="학기"
                  value={semesterCode}
                  onChange={(value, options) => {
                    console.log('value', value);
                    setSemesterCode(value);
                  }}
                  options={[
                    { label: '전체', value: 'null' },
                    ...(Array.isArray(semesterData) && semesterData
                      ? semesterData?.map((item: any) => ({
                          label: item?.semesterName,
                          value: item?.semesterCode,
                        }))
                      : []),
                  ]}
                ></Select>
              </div>
            </li>
            <li>
              <label>{t(`booksManagement.books.column17`)}</label>
              <div>
                <Select
                  placeholder={t(`booksManagement.books.column17`)}
                  mode="multiple"
                  allowClear
                  // onChange={(e) => {
                  //   setClassCodeList(e);
                  // }}
                  onChange={handleChange}
                  options={[
                    { label: '전체', value: 'null' },
                    ...(Array.isArray(data?.data)
                      ? data?.data?.map((item: any) => ({
                          label: item?.className,
                          value: item?.classCode,
                        }))
                      : []),
                  ]}
                  style={{ width: '200px' }}
                  value={classCodeList}
                  maxTagCount={1}
                />
              </div>
            </li>
            <li>
              <label>{t('booksManagement.books.column25')}</label>
              <input
                type="text"
                ref={keywordRef}
                className="form-control w-150p"
                placeholder={t('booksManagement.books.column25')}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    setSearchData({
                      ...searchData,
                      keyword: keywordRef.current.value,
                      bookStatus,
                      semesterCode:
                        semesterCode === 'null' ? null : semesterCode,
                      classCodeList:
                        classCodeList === '' ? null : classCodeList.join(','),
                      page: 1,
                    });
                    handleSelectedReset();
                  }
                }}
              />
              <div className="comm-btn__area">
                <Button
                  className="btn-basic small black"
                  onClick={() => {
                    setSearchData({
                      ...searchData,
                      keyword: keywordRef.current.value,
                      bookStatus,
                      semesterCode:
                        semesterCode === 'null' ? null : semesterCode,
                      semesterType: semesterType === '' ? null : semesterType,
                      classCodeList:
                        classCodeList === '' ? null : classCodeList.join(','),
                      page: 1,
                    });
                    handleSelectedReset();
                  }}
                  text={t('common.button.search')}
                />
              </div>
              <div>
                <Checkbox onChange={(e) => onChange(e)}>
                  {t('booksManagement.books.text1')}
                </Checkbox>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div className="content scrollbar">
        <ErrorResponse error={error} />
        <div>
          <div className="comm-bx__between">
            <div className="comm-sch_result">
              {/* {t('common.text.count')}: {copyBooks?.totalCount ?? 0} */}
              {t('common.text.count')}:{' '}
              {isChecked ? (
                copyBooks?.copyBooksDtos?.filter(
                  (item: any) => item.overdueDay !== null,
                ).length
              ) : (
                <b>{copyBooks?.totalCount ?? 0}</b>
              )}
              {t('common.text.unit')}
            </div>
          </div>
          <div className="comm-table__area">
            <Table
              columns={returnBooksColumns}
              // dataSource={copyBooks?.copyBooksDtos ?? []}
              dataSource={
                isChecked
                  ? copyBooks?.copyBooksDtos?.filter(
                      (item: any) => item.overdueDay !== null,
                    )
                  : copyBooks?.copyBooksDtos ?? []
              }
              // dataSource={copyBooksList?.copyBooksDtos ?? []}
              rowSelection={{
                type: 'checkbox',
                ...rowSelection,
              }}
              loading={isFetching}
              pagination={{
                current: searchData.page,
                pageSize: searchData.pageSize,
              }}
              // onRow={(record: any) => console.log(1)}
              rowClassName="pointer"
              rowKey="no"
            />
          </div>
          <div className="comm-bx__between">
            <div></div>
            <div className="common-paging center">
              <Pagination
                // count={copyBooks?.totalCount ?? 0}
                count={
                  isChecked
                    ? copyBooks?.copyBooksDtos?.filter(
                        (item: any) => item.overdueDay !== null,
                      ).length
                    : copyBooks?.totalCount ?? 0
                }
                page={searchData.page}
                perPage={searchData.pageSize}
                setPage={setPage}
              />
            </div>
            <div className="comm-btn__area right">
              <Button
                className="btn-basic pink"
                onClick={() => {
                  if (selectedBooks.length <= 0) {
                    enqueueSnackbar(
                      t('booksManagement.books.message20'),
                      infoVariant,
                    );
                    return;
                  }

                  returnBooksTrigger(selectedBooks);
                  handleSelectedReset();
                }}
                text={t('booksManagement.books.column42')}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReturnBooks;
